import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import LectureVideo from '../../../components/V2/BlockItem/Lecture/LectureVideo';
import { useLecture } from '../../../hooks/V2/useLecture';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';

const LecturePage = () => {
	const navigate = useNavigate();
	// get lecture ID from params
	const lectureId = useParams<{ lectureId: string }>().lectureId;
	const { data: lecture, refetch: refetchLecture } = useLecture(lectureId);
	console.log('lecture:', lecture);

	useEffect(() => {
		if (lectureId) {
			refetchLecture();
		}
	}, [lectureId, refetchLecture]);

	useEffect(() => {
		console.log('lecture meta:----', lecture?.meta);
	}, [lecture]);

	return (
		<Box minH="full" p="16px" pb="100px">
			<Breadcrumb mb="20px" separator={<ChevronRightIcon boxSize="16px" color="#544D4F" />}>
				<BreadcrumbItem>
					<BreadcrumbLink
						onClick={() => {
							navigate(-1);
						}}
					>
						{lecture?.meta?.tag || 'Masterclass'}
					</BreadcrumbLink>
				</BreadcrumbItem>

				<BreadcrumbItem isCurrentPage color="#4358F6">
					<BreadcrumbLink href="#">View Details</BreadcrumbLink>
				</BreadcrumbItem>
			</Breadcrumb>

			<LectureVideo
				_id={lecture?._id}
				instructorLine={lecture?.meta?.instructorLine}
				title={lecture?.meta?.title}
				videoUrl={lecture?.meta?.videoUrl}
			/>

			{/* Show lecture summary stored in lecture?.meta?.summary */}
			{lecture?.meta?.summary && (
				<Box>
					<Box fontSize="20px" fontWeight="extrabold" mt="40px">
						Summary
					</Box>
					<Box mt="20px">{lecture?.meta?.summary}</Box>
				</Box>
			)}
		</Box>
	);
};

export default LecturePage;
